import React, { Component } from 'react'
import './Other.css'
// let otherBusinessInterest = 'Details not available'
class Other extends Component {
    constructor(props) {
        super(props)

        this.state = {
            otherBusinessInterest: 'Details not available'
        }
    }

    // componentWillReceiveProps(nextProps){
    //     otherBusinessInterest=nextProps.transporter_data.other_business_interest;
    //     if(otherBusinessInterest==undefined || otherBusinessInterest==null){
    //         otherBusinessInterest='Details not available'

    //     }
    // }

    static getDerivedStateFromProps(nextProps, prevState) {
        // otherBusinessInterest=nextProps.transporter_data.other_business_interest;
        // if(otherBusinessInterest==undefined || otherBusinessInterest==null){
        //     otherBusinessInterest='Details not available'

        // }
        if (nextProps.transporter_data.other_business_interest === undefined || nextProps.transporter_data.other_business_interest === null) {
            return {
                otherBusinessInterest: 'Details not available'
            }
        }
        else {
            return {
                otherBusinessInterest: nextProps.transporter_data.other_business_interest
            }
        }
    }

    render() {
        const{otherBusinessInterest}=this.state
        return (
            <>
                <div className="othercard">
                    <div className="othercontainer row">
                        <div className="col-12">
                            <h3 className="data_header">Other Business Interest</h3>
                        </div>
                        <div className="col-12">
                            {(otherBusinessInterest) ? (<span>{otherBusinessInterest}</span>) : (<p>Details not available</p>)}
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default Other
